import React from 'react';
import './BusinessNewsletter.css'

const BusinessNewsletter = () => {
    return (
        <section className="newsletter-section">
            <div className="container">
                <div className="newsletter-heading">
                    <h3>Receive updates, business tips and more.....</h3>
                </div>
                <div className="newsletter-content">
                    <div className="input-element">
                        <input type="text" placeholder="Name" />
                    </div>
                    <div className="input-element">
                        <input type="text" placeholder="Email" />
                    </div>
                    <div className="submit-element">
                        <button className="newsletter-submit">Sign Up</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BusinessNewsletter
